import { combineReducers } from "redux";
import studentapplications from "../features/admin/student/studentapplication/Slice";
import hotelapplications from "../features/admin/student/hotelapplication/Slice";
import tickets from "../features/admin/student/ticketraised/Slice";
import add_student_documents from "../features/admin/student/add_student_documents/Slice";
import studentregistration from "../features/admin/student/studentauth/Slice";

const studentapplication = combineReducers({
  studentapplications: studentapplications,
  hotelapplications: hotelapplications,
  tickets: tickets,
  add_student_documents: add_student_documents,
  studentregistration: studentregistration,
});

export default studentapplication;
